import { useCallback, useRef } from 'react';

export const useDebouncedFunction = (func: Function, msDelay: number) => {
	const timeoutRef = useRef<NodeJS.Timeout | undefined>();

	const clearTimer = () => {
		if (timeoutRef.current) {
			clearTimeout(timeoutRef.current);
			timeoutRef.current = undefined;
		}
	};

	return useCallback(
		(...args: any) => {
			clearTimer();
			timeoutRef.current = setTimeout(() => func(...args), msDelay);
		},
		[func, msDelay],
	);
};
